export const Closed = [
  { label: 'Todos', value: 'Todos' },
  { label: 'Sim', value: true },
  { label: 'Não', value: false }
];
